import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { FormikValues, useFormikContext } from "formik";
import { Box, FormControlLabel, Radio, RadioGroup } from "@mui/material";

import FormStepTitle from "../../form/FormStepTitle";
import FileUploadButtonWithoutPreview from "../../../../../common/fileUploadButton/FileUploadButtonWithoutPreview";

import { H5 } from "../../../styles";
import styles from "../../../styles.module.scss";

const supportiveDocumentsInfo = [
  {
    id: 1,
    name: "medicalCertificate",
    label: "Medical Bills",
    description:
      "Supportive documents like OPD Assessment, ECG, TMT, Echo cardiography, Lab (Trop T, Cardiac enzymes), ECHO or any other elevent clinical report.",
  },
];

const supportiveIDProof = [
  {
    id: 1,
    name: "card",
    label: "card",
    description: "Upload Aadhaar/Voter ID card/Driving license",
  },
];

const SupportiveDocuments = () => {
  const { id } = useParams();

  const { setFieldTouched, values, setFieldValue } =
    useFormikContext<FormikValues>();

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue("isLowerIncomeBeneficiary", e.target.value);
  };

  useEffect(() => {
    setFieldTouched("card", !!id);
    setFieldTouched("incomeCertificate", !!id);
    setFieldTouched("supportiveDocs", !!id);
    // setFieldTouched("adharCard", false);
  }, [id, setFieldTouched]);

  return (
    <>
      <>
        <FormStepTitle title="ID Proof" required />
        {supportiveIDProof?.map((idCard, index) => (
          <Box className={styles.mTopBottom20} key={index}>
            <p>{idCard?.description}</p>
            <FileUploadButtonWithoutPreview
              label={idCard?.label}
              index={index}
              name={idCard.name}
              multiple
            />
          </Box>
        ))}
        <Box className={styles.mTopBottom20}>
          <H5> Is patients income less than 2,50,000 INR?</H5>
          <>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={"false"}
              name="radio-buttons-group"
              value={values?.isLowerIncomeBeneficiary}
              onChange={(e) => handleValueChange(e)}
            >
              <FormControlLabel
                value={"true"}
                control={<Radio />}
                label="Yes"
              />
              <FormControlLabel
                value={"false"}
                control={<Radio />}
                label="No"
              />
            </RadioGroup>
          </>
        </Box>
        {values.isLowerIncomeBeneficiary === "true" && (
          <Box className={styles.mTopBottom20}>
            <H5>Upload Income Certificate Document (From CO office)</H5>
            <FileUploadButtonWithoutPreview
              index={0}
              label="Income Certificate"
              name={"incomeCertificate"}
            />
          </Box>
        )}
      </>
      <Box>
        <FormStepTitle title="Supportive Documents*" required />
        {supportiveDocumentsInfo?.map((idCard: any, index: number) => (
          <Box className={styles.mTopBottom20} key={index}>
            <p>{idCard?.description}</p>
            <FileUploadButtonWithoutPreview
              label={idCard?.label}
              index={index}
              name={"supportiveDocs"}
              multiple
            />
          </Box>
        ))}
      </Box>
    </>
  );
};

export default SupportiveDocuments;
